export const prepareKeyValuePairs = (data, fieldsMap, keyFieldName = 'name', valueFieldName = 'value') => {
    const meta = [];
    Object.entries(data).map(([name, value]) => {
        if (!fieldsMap[name] || !value) {
            return;
        }
        let formattedValue = value;
        if (Array.isArray(formattedValue)) {
            formattedValue = formattedValue.join(', ');
        }
        meta.push({
            [keyFieldName]: fieldsMap[name],
            [valueFieldName]: formattedValue
        });
    });
    return meta;
};
export const removeEmptyFields = (data) => {
    return Object.entries(data).reduce((result, [key, value]) => {
        if (value) {
            result[key] = value;
        }
        return result;
    }, {});
};
export const filterOutFields = (data, allowedFields) => {
    return Object.fromEntries(allowedFields.map((k) => [k, data[k]]));
};
